import React, { Component } from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { kodFarbyCell } from "../../common/Helpers";

class RozdielGrid extends Component {
    popisCell = props => {
        return <td dangerouslySetInnerHTML={{ __html: props.dataItem.popis }}></td>;
    };

    rozdielPopisCell = props => {
        var split = props.dataItem.retVe ? props.dataItem.retVe.split(",") : [];
        var htmlOutput = split.map((item, i) => {
            if (item.startsWith("-")) {
                item = item.substr(1);
            } else {
                var style = { color: "red" };
            }
            return (
                <React.Fragment key={i}>
                    <span style={style}>{item}</span>
                    <span>{split.length === i + 1 ? "" : ", "}</span>
                </React.Fragment>
            );
        });

        return <td>{htmlOutput}</td>;
    };

    render() {
        return (
            <Grid style={{ height: "150px" }} data={this.props.items} className="PrijemBalikaSkenovaneGrid">
                <GridColumn cell={this.popisCell} />
                <GridColumn cell={kodFarbyCell} width="30px" />
                <GridColumn cell={this.rozdielPopisCell} />
                <GridColumn field="stavText" className="center-cell" width="150px" />
            </Grid>
        );
    }
}

export default RozdielGrid;



// WEBPACK FOOTER //
// ./src/components/dialogs/PrijemBalika/RozdielGrid.js